const PRODUCTION_BRANCH_ID = "master";
const SCORECARD_LAYOUT_PATH = "UserDefinedFiles\\Scorecard\\";
const METRIC_SET_NAME = "Metricset";
const DRAFT_SENTENCE_NAME = "draft";
const entityToVivaceEntity = {
  metric: "metrics",
  column: "columns",
  segment: "segments",
  template: "templates",
  enrichment: "enrichments",
  analysis: "analysis",
  /**
   * TODO routes
   * cannot map the singular scorecard "layout" route to both the plural (scorecards) pivot
   * and singular entity
   */
  scorecards: "scorecards",
  scorecard: "scorecard",
  preview: "preview",
  "analysis-template": "analysis-templates",
  configuration: "settings"
};
const previewScorecardLogProperties = {
  url: "url",
  isUnifiedView: "isUnifiedView",
  experimentStepOption: "experimentStepOption",
  experimentStepId: "experimentStepId",
  publishStatus: "publishStatus",
  metricSetName: "metricSetName",
  draftName: "draftName",
  analysisCreateErrorMessage: "analysisCreateErrorMessage",
  metricSetVersion: "metricSetVersion",
  metricSetVersionId: "metricSetVersionId",
  previewScorecardOptInLevel: "previewScorecardOptInLevel",
  isPreviewScorecardUserOptInFlag: "isPreviewScorecardUserOptInFlag",
  isPreviewScorecardOptOutFlag: "isPreviewScorecardOptOutFlag",
  isPreviewScorecard: "isPreviewScorecard",
  templateName: "templateName",
  studyName: "studyName",
  studyDescription: "studyDescription",
  studyId: "studyId",
  filterOption: "fliterOption"
};
const MAUI_METRIC_LOG = {
  ANALYSIS_CREATED: "Analysis_Created",
  ANALYSIS_CREATE_ERROR: "Analysis_Create_Error",
  PREVIEW_SCORECARD_USER_OPT_IN: "Preview_Scorecard_User_Opt_In",
  PREVIEW_SCORECARD_USER_OPT_OUT: "Preview_Scorecard_User_Opt_Out",
  PREVIEW_SCORECARD_STEP_SELECTION_OPTION: "Preview_Scorecard_Step_Selection_Option",
  PUBLISHED_VERSIONS_FILTER_OPTION: "Published_Versions_Filter_Option",
  RECENT_ANALYSIS_FILTER_OPTION: "Recent_Analysis_Filter_Option"
};
export {
  DRAFT_SENTENCE_NAME,
  MAUI_METRIC_LOG,
  METRIC_SET_NAME,
  PRODUCTION_BRANCH_ID,
  SCORECARD_LAYOUT_PATH,
  entityToVivaceEntity,
  previewScorecardLogProperties
};
//# sourceMappingURL=maui.constants.js.map
